module.exports = __webpack_public_path__ + "img/alarms.5e290657.png";